import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import ConnectedFormControl from '../FormControl/FormControl.js';
import { isText } from '../Util/validations.js';

const LastName = (_param)=> {
    var { label , errorMessage , validations =[
        isText
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage",
        "validations"
    ]);
    return React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
        id: "lastName",
        "data-t": "last-name",
        label: label,
        errorMessage: errorMessage,
        validations: validations
    }, rest));
};

export { LastName as default };
//# sourceMappingURL=LastName.js.map
